import { Box } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { QuizItem } from '../../Quiz/QuizItem';
import { ShowQuizResult } from '../../Quiz/ShowQuizResult';

export const QuizModal = () => {
    const { showResult } = useSelector(state => state.quiz);
    return <Box>{!showResult ? <QuizItem /> : <ShowQuizResult />}</Box>;
};
